<template>
	<el-dialog class="cooperationProgress_monitoring_dialog" :visible.sync="visible" width="400px" :close-on-click-modal="false">
		<div slot="title">
			<span class="fz-14 yx-pingfang-Medium yx-color-g-9">规则说明</span>
		</div>
		<div class="font-h4-medium">
			开关开启场景下，自动筛选分配达人同时会自动获取达人公开联系方式直到店铺当日可查看联系方式次数消耗完，则不继续获取公开联系方式但不影响获取达人。
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="visible = false">我知道了</el-button>
		</span>
	</el-dialog>
</template>
<script>
export default {
	data() {
		return {
			visible: false,
		};
	},
	methods: {
		show() {
			this.visible = true;
		},
	},
};
</script>